import "../../index53.css";
import { jsx as eo } from "react/jsx-runtime";
import { useState as d, useMemo as u, useCallback as h } from "react";
import { a as M, i as no, b as to } from "../../type-BFTbooL7.js";
import { _ as so } from "../../cs-piwRuCFZ.js";
import { u as io } from "../../list-Bv4dmpyM.js";
import { l as y } from "../../transform-VOqkQszh.js";
import ao from "../SelectInputContainer/index.js";
import { d as T } from "../../common-CLw-EvUg.js";
import ro from "./Option/index.js";
const co = "_option_1kpl9_1", lo = "_active_1kpl9_7", po = "_icon_1kpl9_11", uo = "_label_1kpl9_17", f = {
  option: co,
  active: lo,
  icon: po,
  label: uo
}, b = [];
function bo(L) {
  const {
    keySelector: n,
    labelSelector: t,
    name: l,
    onChange: m,
    onOptionsChange: O,
    options: V,
    optionsPending: j,
    optionsErrored: R,
    value: q,
    sortFunction: p,
    searchOptions: A,
    onSearchValueChange: c,
    onShowDropdownChange: _,
    hideOptionFilter: g,
    selectedOnTop: F,
    ...B
  } = L, C = V ?? b, k = A ?? b, e = q ?? b, [r, D] = d(), [E, z] = d(!1), [G, H] = d(!1), [
    J,
    v
  ] = d(), [w, I] = d({}), K = u(
    () => y(C, n, (o) => o),
    [C, n]
  ), P = u(
    () => y(C, n, t),
    [C, n, t]
  ), Q = u(
    () => e.map((o) => P[o] ?? "?").join(", "),
    [e, P]
  ), x = u(
    () => e.map((o) => K[o]).filter(M),
    [e, K]
  ), U = u(
    () => {
      const o = io(
        [...k, ...x],
        n
      );
      if (!F)
        return p ? p(o, r, t) : o;
      const s = o.filter((a) => w[n(a)]), i = o.filter((a) => !w[n(a)] && (no(g) || g(a)));
      return p ? [
        ...T(s, r, t),
        ...p(i, r, t)
      ] : [
        ...T(s, r, t),
        ...i
      ];
    },
    [
      F,
      n,
      t,
      r,
      k,
      w,
      x,
      p,
      g
    ]
  ), W = h(
    (o) => {
      D(o), c && c(o);
    },
    [c]
  ), X = h(
    (o) => {
      z(o), _ && _(o), o ? (I(
        y(
          e,
          (s) => s,
          () => !0
        )
      ), v(void 0)) : (I({}), v(void 0), D(void 0), c && c(void 0));
    },
    [e, c, _]
  ), Y = h(
    (o, s) => {
      const i = e.findIndex((a) => a === o) !== -1;
      return {
        children: t(s),
        containerClassName: so(f.option, i && f.active),
        title: t(s),
        isActive: i,
        labelClassName: f.label,
        iconClassName: f.icon
      };
    },
    [t, e]
  ), Z = h(
    (o, s) => {
      const i = [...e], a = e.findIndex((S) => S === o);
      a !== -1 ? i.splice(a, 1) : (i.push(o), O && O((S) => {
        const N = S ?? [];
        return N.find((oo) => n(oo) === o) ? S : [...N, s];
      })), m(i, l);
    },
    [e, m, l, O, n]
  ), $ = h(
    () => {
      m([], l);
    },
    [l, m]
  );
  return /* @__PURE__ */ eo(
    ao,
    {
      ...B,
      name: l,
      options: U,
      optionsPending: j,
      optionsFiltered: to(r) && r.length > 0,
      optionsErrored: R,
      optionKeySelector: n,
      optionRenderer: ro,
      optionRendererParams: Y,
      optionContainerClassName: f.optionContainer,
      onOptionClick: Z,
      valueDisplay: Q,
      onClearButtonClick: $,
      searchText: r,
      onSearchTextChange: W,
      dropdownShown: E,
      onDropdownShownChange: X,
      focused: G,
      onFocusedChange: H,
      focusedKey: J,
      onFocusedKeyChange: v,
      persistentOptionPopup: !0,
      nonClearable: !1,
      hasValue: M(e) && e.length > 0
    }
  );
}
export {
  bo as default
};
